module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "pairs_created.0fd9430a.png";